import { Container, Row, Col } from "react-bootstrap";
import SearchHeader from "./SearchHeader";
import ButtonHeader from "./ButtonHeader";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import TooltipComponent from "../TooltipComponent";
import { FaPlusCircle } from "react-icons/fa";
import { MdAddCard } from "react-icons/md";

const TableHeader = ({
  align = "top",
  searchValue,
  setSearchText,
  button = {},
  userPermission = { create: true },
  openImport,
  extraComponent = null,
}) => {
  const {
    title = "Add",
    to = "/",
    noDrop = false,
    otherButtons = [],
    show = true,
    toClick = false,
  } = button;
  const navigate = useNavigate();

  const [isSmScreen, setIsSmScreen] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => setIsSmScreen(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="d-flex align-items-center gap-2 flex-column flex-md-row">
      <SearchHeader setSearchText={setSearchText} value={searchValue} />
      <div>{extraComponent}</div>
      {show && userPermission?.create ? (
        <TooltipComponent align={align} title={title}>
          <span
            // onClick={() => handleClickExcelPdf("2")}
            onClick={toClick ? toClick : () => navigate(to)}

            className="fs-2 text-success cursor-pointer"
          >
            <MdAddCard />
          </span>
        </TooltipComponent>
      ) : null}
    </div>
  );
};

export default TableHeader;